export const DESKTOP_WIDTH = 768;
export const MIN_WIDTH = 550;
export const MAX_WIDTH = 1900;
export const SMALLER_MAX_WIDTH = 928;
export const LEFT_SIDEBAR_WIDTH = 64;
export const LEFT_SIDEBAR_WIDTH_AND_MARGIN = 88;

export const TABLET = 'tablet';
export const DESKTOP = 'desktop';

export const APP_INITIALIZATION_SUCCESS = 'APP_INITIALIZATION_SUCCESS';
export const APP_INITIALIZATION_FAILURE = 'APP_INITIALIZATION_FAILURE';
export const APP_CHANGE_LANGUAGE = 'APP_CHANGE_LANGUAGE';

export const APP_GET_LOGO_REQUEST = 'APP_GET_LOGO_REQUEST';
export const APP_GET_LOGO_REQUEST_SUCCESS = 'APP_GET_LOGO_REQUEST_SUCCESS';
export const APP_GET_LOGO_REQUEST_FAILURE = 'APP_GET_LOGO_REQUEST_FAILURE';

export const APP_SET_BREAK_POINT = 'APP_SET_BREAK_POINT';

export const APP_NAVIGATION_HIDDEN = 'APP_NAVIGATION_HIDDEN';
